import { useCallback } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import { useLocalStorage } from '../../../services/hooks';

const FeatureFlagMenuItem = ({ feature }: { feature: { key: string; title: string; description: string } }) => {
  const [features, setFeatures] = useLocalStorage<Record<string, boolean>>('features', {});

  const handleToggleFeature = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setFeatures(prev => ({ ...prev, [feature.key]: !prev[feature.key] }));
    },
    [feature.key, setFeatures]
  );

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack>
        <Typography variant="body1">{feature.title}</Typography>
        <Typography variant="body2">{feature.description}</Typography>
      </Stack>
      <Switch checked={!!features[feature.key]} onClick={handleToggleFeature} />
    </Stack>
  );
};

export default FeatureFlagMenuItem;
